import { Row, Col, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ViewProductsDetalisHook from "./../../hook/products/view-products-detalis-hook";
import { ToastContainer } from "react-toastify";
import ResponsiveTable from "./ResponsiveTable/ResponsiveTable";
import AddToCartHook from "./../../hook/cart/add-to-cart-hook";
import DisableButton from "../Uitily/DisableButton";

const ProductText = () => {
  const { id } = useParams();
  const [item, , cat, brand] = ViewProductsDetalisHook(id);
  const [colorClick, indexColor, addToCartHandel, checkIsComplate] =
    AddToCartHook(id, item);

  return (
    <div>
      {item !== undefined || item !== null ? (
        <>
          <Row className="mt-2">
            <div className="cat-text">{cat.name} الفئة:</div>
          </Row>
          <Row>
            <Col md="8">
              <div className="cat-title d-inline">
                {item.title}
                <div className="cat-rate d-inline mx-3">
                  {item.ratingsAverage}
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">الماركة :</div>
              <div className="barnd-text d-inline mx-1">{brand.name} </div>
            </Col>
          </Row>
          <Row></Row>
          <Row>
            <Col md="8" className="mt-1">
              <div className="cat-text d-inline">الاوان المتاحة : </div>
              {item.colors
                ? item.colors.map((color, index) => {
                    return (
                      <button
                        key={index}
                        onClick={() => colorClick(index, color)}
                        className="color d-inline-block"
                        style={{
                          backgroundColor: color,
                          border:
                            indexColor === index ? "3px solid black" : "none",
                        }}
                      ></button>
                    );
                  })
                : null}
            </Col>
            <Row>
              <Col>
                <div className="cat-text d-inline">
                  الكمية المتاحة : {item.quantity}{" "}
                </div>
              </Col>
            </Row>
          </Row>

          <Row className="mt-4">
            <div className="cat-text">المواصفات :</div>
          </Row>
          <Row className="mt-2">
            <Col md="10">
              <div
                className="product-description d-inline"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {item.description ? (
                  <ResponsiveTable data={item.description} />
                ) : null}
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md="12">
              {item.priceAfterDiscount >= 1 ? (
                <div className="product-price d-inline px-3 py-3 border">
                  <span style={{ textDecorationLine: "line-through" }}>
                    {" "}
                    {item.price}
                  </span>{" "}
                  {item.priceAfterDiscount} جنية
                </div>
              ) : (
                <div className="product-price d-inline px-3 py-3 border">
                  <span> {item.price}</span> جنية{" "}
                </div>
              )}
              {checkIsComplate() ? (
                <button
                  onClick={addToCartHandel}
                  className="product-cart-add mx-3"
                >
                  اضف للعربة
                </button>
              ) : (
                <DisableButton
                  title="اضف للعربة"
                  className="product-cart-add mx-3 bg-white text-black-50"
                  style={{
                    cursor: "auto",
                  }}
                />
              )}
            </Col>
          </Row>
          <ToastContainer />
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default ProductText;
